import Cookies from 'js-cookie'

export const clearToken=()=> {
    Cookies.remove("accessToken")
    Cookies.remove("refreshToken")
}
